import StorageDecorator from './storages';

export const LocalStorage = new StorageDecorator('localStorage');
export const SessionStorage = new StorageDecorator('sessionStorage');
